import { Router } from '@angular/router'
import { onError } from '@apollo/client/link/error'
import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { extractServerGraphQLErrors } from './util/throwIfCustomError'
import { AuthService } from './services/auth.service'

export function createAuthErrorLink(auth: AuthService, router: Router) {
  let handledGeneration: number | undefined
  return onError(({ error, operation }) => {
    if (
      handledGeneration === auth.generation ||
      operation.getContext().authGeneration !== auth.generation
    )
      return
    const errors = CombinedGraphQLErrors.is(error)
      ? error.errors
      : extractServerGraphQLErrors(error)
    const reason = errors.find(
      (item) =>
        item.extensions?.code === 'UNAUTHENTICATED' &&
        ['MFA_REQUIRED', 'SESSION_INVALIDATED', 'TOKEN_INVALID'].includes(
          String(item.extensions?.reason),
        ),
    )?.extensions?.reason
    if (
      !reason ||
      (reason === 'MFA_REQUIRED' && router.url.startsWith('/auth/'))
    )
      return
    handledGeneration = auth.generation
    if (reason !== 'TOKEN_INVALID') {
      const navigation = router.currentNavigation()
      const returnUrl = navigation
        ? router.serializeUrl(navigation.finalUrl ?? navigation.extractedUrl)
        : router.url
      // 認証ページ自身で元の戻り先を上書きすると、再認証後に同じページへ戻ってしまう。
      if (!returnUrl.startsWith('/auth/')) auth.setReturnUrl(returnUrl)
    }
    const queryParams =
      reason === 'SESSION_INVALIDATED'
        ? { error: 'session_invalidated' }
        : reason === 'TOKEN_INVALID'
          ? { error: 'token_error' }
          : undefined
    void auth
      .signOutPreservingReturnUrl()
      .then(() => auth.redirectToLogin(queryParams))
      .catch((error) =>
        console.error('Failed to sign out after authentication error:', error),
      )
  })
}
